import useGetMembership from '@my-pages/features/membership/hooks/useGetMembership.ts';
import { useGetPerson } from '@my-pages/hooks/useGetPerson.ts';
import { formatDate } from '@shared/utils/dateUtils.ts';
import ToggleMembershipCard from '@my-pages/features/membership/components/ToggleMembershipCard.tsx';
import { SuspenseQueryErrorHandling } from '@shared/components/SuspenseQueryErrorHandling.tsx';
import { FeatureFlag } from '@shared/_legacy/api/umbraco-api';
import Feature from '@shared/features/feature-flags/components/Feature.tsx';

const MembershipInformationCardContent = () => {
    const member = useGetPerson();
    const membership = useGetMembership();

    return (
        <div className='ft-table ft-responsive-sm table-mark-empty mb-0 font-size-sm'>
            <div className='ft-tr'>
                <div className='ft-th'>Medlemsnummer</div>
                <div className='ft-td highlight-mask'>{member?.memberNumber}</div>
            </div>
            {member?.originalEntryDate && (
                <div className='ft-tr'>
                    <div className='ft-th'>Medlem sedan</div>
                    <div className='ft-td highlight-mask'>{formatDate(member.originalEntryDate)}</div>
                </div>
            )}
            <div className='ft-tr'>
                <div className='ft-th'>Medlemsform</div>
                <div className='ft-td'>{membership.name}</div>
            </div>
            <Feature feature={FeatureFlag.MEMBERSHIP_CARD}>
                <ToggleMembershipCard />
            </Feature>
        </div>
    );
};

const MembershipInformationCard = () => {
    return (
        <div className='card card-body mb-4'>
            <h4>Medlemskap</h4>
            <SuspenseQueryErrorHandling errorMessage='Kunde inte hämta uppgifter kring ditt medlemskap.'>
                <MembershipInformationCardContent />
            </SuspenseQueryErrorHandling>
        </div>
    );
};

export default MembershipInformationCard;
